import React, { useEffect } from 'react'
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import HistoryOfPresentIllnessForm from '../../../../itrust_common/components/authorised/examFormPartial/HistoryOfPresentIllnessForm';

function HpiForm(props) {
  const { handleSubmit, template } = props;

  useEffect(() => {
    return () => {
      if (props.dirty) {
        handleSubmit();
      }
    }
  }, [props.dirty])

  return (
    <form onSubmit={handleSubmit}>
      <HistoryOfPresentIllnessForm pprops={props} template={template} isTemplate={false} />
    </form>
  )
}

HpiForm = reduxForm({
  form: 'examHpiForm',
  enableReinitialize: true,
  // destroyOnUnmount: false
})(HpiForm)

const mapStateToProps = state => {
  const { exam } = state.exam
  return {
    initialValues: {
      id: exam.id,
      hpis_attributes: exam.hpis_attributes,
    }
  }
}

export default connect(mapStateToProps)(HpiForm);